export default __webpack_public_path__ + "static/img1-a27cf174ed26ee13745142a7b62137d6.png";